import { Fragment, useState, useEffect, useContext } from 'react';
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import TrafficAnalyticsCategoryMenu, { CategoryMenu as TrafficCategoryMenu } from '../../../components/dashboard/traffic/TrafficAnalyticsCategoryMenu';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TrafficAnalyticsByWeek from './TrafficAnalyticsByWeek';
import TrafficAnalyticsByTime from './TrafficAnalyticsByTime';
import TrafficAnalyticsByDemographics from './TrafficAnalyticsByDemographics';
import MultipleDropDownMenu from '../../../components/shared/MultipleDropDownMenu';
import ViewDropDownMenu from '../../../components/shared/ViewDropDownMenu';
import { PageContext } from '../../../context/page-context';
import useStores from '../../../hooks/useStores';
import { PageFilter } from '../../../model/page';
import useTrafficAnalytics from '../../../hooks/useTrafficAnalytics';
import { TrafficAnalyticsContext } from '../../../context/trafficanalytics-context';


export default function TrafficAnalytics() {
  const [category, setCategory] = useState('');
  let { url } = useRouteMatch();
  const history = useHistory();
  const { status: storesStatus, data: stores, isFetching: storeIsFetching } = useStores();
  const { activeFilter, filter, setStores, setStoresFilter, setIsLoaded } = useContext(PageContext);
  const [savedViews] = useState<PageFilter[]>([]);
  const [selectedIndex] = useState('all');

  const defaultTimeRange = 30;
  let { status, data, error, isFetching } = useTrafficAnalytics(defaultTimeRange);


  useEffect(() => {
    if (setIsLoaded === undefined || setStores === undefined || storeIsFetching === undefined || stores === undefined) return;
    if (storeIsFetching || storesStatus !== "success") {
      setIsLoaded(false);
    }
    if (!storeIsFetching && storesStatus === "success" && stores && setStores) {
      setStores(stores);
      setIsLoaded(true);
    }
  }, [setIsLoaded, storesStatus, setStores, storeIsFetching, stores]);

  useEffect(() => {
    if (url.indexOf('byweek') !== -1) {
      setCategory('byweek');
    } else if (url.indexOf('bytime') !== -1) {
      setCategory('bytime');
    } else if (url.indexOf('bydemographics') !== -1) {
      setCategory('bydemographics');
    }
  }, [category, url]);

  interface UrlParam {
    categoryName: string;
  }

  const { categoryName }: UrlParam = useParams();
  const selectCategory = (cat: string) => {
    setCategory(cat);
    if (url === '') {
      url = '/traffic';
    }
    history.push(`/traffic/${cat}`);
  }

  const categories: TrafficCategoryMenu[] = [{
    name: 'byweek',
    label: 'By Week'
  },
  {
    name: 'bytime',
    label: 'By Time'
  },
  {
    name: 'bydemographics',
    label: 'By Demographics'
  }
  ];


  return (
    <Fragment>

      <TrafficAnalyticsContext.Provider value={{ status, data, error, isFetching: Boolean(isFetching), timeRange: defaultTimeRange }}>

        <Stack direction="row" sx={{ mb: 3 }} spacing={2}>
          <Button color="secondary" sx={{ backgroundColor: 'text.secondary', color: 'white' }} variant="contained">Save View</Button>
          <ViewDropDownMenu label="Saved Views" views={savedViews} />
        </Stack>

        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', pb: 2, flexWrap: 'wrap' }}>
          <TrafficAnalyticsCategoryMenu category={category} selectCategory={selectCategory} categories={categories} />

          <Stack direction="row" spacing={1} >
      
            <MultipleDropDownMenu
              multipleLabel='Stores'
              label="Store"
              search={true}
              options={filter.stores && filter.stores.length > 0 ? filter.stores : stores ? stores : []}
              selectHandler={setStoresFilter}
              selected={activeFilter.stores}
            />
          </Stack>

        </Stack>

        <Grid container={true} spacing={3} sx={{ pt: 3 }}>

          {categoryName === 'byweek' && <TrafficAnalyticsByWeek geolocation={selectedIndex === 'all'} />}
          {categoryName === 'bytime' && <TrafficAnalyticsByTime />}
          {categoryName === 'bydemographics' && <TrafficAnalyticsByDemographics />}

        </Grid>

      </TrafficAnalyticsContext.Provider>

    </Fragment>
  )

}
